"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var formatting_condition_converter_1 = require("./formatting-condition-converter");
var idm_report_export_service_client_js_1 = require("@synisys/idm-report-export-service-client-js");
/**
 * Created by Hayk.Andriasyan on 4/19/2018.
 */
var ColumnFormattingRuleConverter = /** @class */ (function () {
    function ColumnFormattingRuleConverter() {
    }
    ColumnFormattingRuleConverter.convertJsonToColumnFormattingRule = function (columnFormattingRuleJson) {
        var formattingConditionsJson = columnFormattingRuleJson['formattingConditions'];
        var formattingConditions = [];
        for (var _i = 0, formattingConditionsJson_1 = formattingConditionsJson; _i < formattingConditionsJson_1.length; _i++) {
            var formattingCondition = formattingConditionsJson_1[_i];
            if (formatting_condition_converter_1.FormattingConditionConverter.isInstanceOfBetweenFormattingCondition(formattingCondition)) {
                formattingConditions.push(formatting_condition_converter_1.FormattingConditionConverter.convertJsonToBetweenFormattingCondition(formattingCondition));
            }
            else if (formatting_condition_converter_1.FormattingConditionConverter.isInstanceOfConstantFormattingCondition(formattingCondition)) {
                formattingConditions.push(formatting_condition_converter_1.FormattingConditionConverter.convertJsonToConstantFormattingCondition(formattingCondition));
            }
            else {
                throw new Error("Unknown type of formatting condition " + formattingCondition.constructor.name);
            }
        }
        return new idm_report_export_service_client_js_1.ColumnFormattingRuleImpl(formattingConditions);
    };
    return ColumnFormattingRuleConverter;
}());
exports.ColumnFormattingRuleConverter = ColumnFormattingRuleConverter;
//# sourceMappingURL=column-formatting-rule-converter.js.map